import type { HgGetClubOptionsReply } from '@ps/web-shared-api-types/v0/SwHomeGames';
import produce from 'immer';

import type { PageData } from '../../types/common';

interface Payload {
  clubId: number;
  response: HgGetClubOptionsReply;
}

export const setClubOptions = (state: PageData, { response, clubId }: Payload) =>
  produce(state, (draft) => {
    draft.clubOptionsById[clubId] = response;
  });
